export default {
  message: {
    Tour: {
      continue: "继续",
      back: "返回",
      finish: "完成"
    },
    Login: {
      title: "家长登录",
      sign_in: "登录",
      login_fail: "认证失败。请重试或联系学校获取帮助。",
      forgot_password: "忘记密码",
      create_account: "创建账户",
      password: "密码",
      confirm_password: "确认密码",
      password_reminder: "密码提示",
      enter_email: "请输入您的电子邮箱地址",
      validation_error: "验证错误信息",
      password_reminder_error_no_user_register: "未找到您输入的用户名。请重试或创建新账户。",
      password_reminder_error_no_user: "未找到您输入的用户名。",
      password_reminder_sent: "已向 {email} 发送包含进一步说明的电子邮件。",
      password_reminder_sent_message:
        "邮件可能需要几分钟才能到达。如果未收到，请检查垃圾邮件文件夹。",
      password_trouble_email: "如果仍有问题，请联系 {email}。",
      password_trouble_school: "如果仍有问题，请联系学校获取帮助。",
      return_to_sign_in: "返回登录",
      create_my_account: "创建我的账户",
      or_sign_in_with: "或使用以下方式登录",
      password_reset: "请选择一个新的账户密码。",
      password_reset_warning: "如果您并未请求更改密码，请立即联系学校管理员。",
      password_update: "选择新密码",
      password_update_confirm: "确认新密码",
      password_update_success: "您的新密码已保存。"
    },
    AccountSettings: {
      title: "账户设置",
      first_name: "名字",
      last_name: "姓氏",
      email: "电子邮箱",
      username: "用户名",
      password: "密码",
      students: "学生",
      teachers: "教师",
      external_id: "外部ID",
      phone: "电话号码",
      phone_required: "电话号码为必填项",
      edit: "编辑",
      remove: "移除",
      add: "添加",
      remove_message: "您确定要移除此学生吗？",
      yes: "是",
      no: "否",
      add_student: "添加学生",
      close: "关闭",
      save: "保存更改",
      cancel: "取消",
      student_alert_message: "您必须至少添加一名学生。",
      logout: "退出登录"
    },
    TrialStatus: {
      title: "Update Trial Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      updatedSuccess: "Trial status updated successfully",
      updateError: "Failed to update trial status",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    LeadStatus: {
      title: "Update Lead Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      reject: "Reject",
      updatedSuccess: "Lead status updated successfully",
      updateError: "Failed to update lead status",
      convertedNote: "This marks the lead as a customer. If a school exists, it may be set to active.",
      suppressedNote: "This suppresses the lead. You can restore it later from Suppressed.",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    WelcomeEmail: {
      title: "Send welcome email?",
      schoolLabel: "School",
      districtLabel: "District",
      contactLabel: "Contact",
      emailLabel: "Email",
      subdomainLabel: "Subdomain",
      usernameLabel: "Username",
      body: "PTC Wizard will email this account's admin-site credentials and documentation links.",
      confirm: "Send email",
      cancel: "Cancel",
      success: "Welcome email sent",
      error: "Failed to send welcome email",
      tooltip: "Send welcome email"
    },
    Navbar: {
      my_meetings: "我的会议",
      language: "中文",
      help: "帮助",
      account_settings: "账户设置",
      user_management: "User Management",
      logout: "退出登录"
    },
    SubNavbar: {
      meeting: "会议",
      event: "活动",
      print: "打印",
      email: "电子邮件",
      export: "导出"
    },
    ConferenceCard: {
      add_edit_meetings: "添加/编辑会议",
      opening: "开放中",
      closed: "已关闭"
    },
    Agenda: {
      full_agenda: "完整日程",
      empty_state_title: "未找到您的会议安排。",
      empty_state_message: "如有任何疑问，请联系您的学校代表。",
      confirmation_modal_title: "日程已确认",
      confirmation_modal_message: "您的日程已成功确认，邮件已发送给您。",
      complete_button: "完成！"
    },
    AgendaCard: {
      room: "教室不可用",
      room_with_value: "教室：{room}",
      virtual_meeting: "线上会议",
      all_conferences: "所有会议",
      conference: "会议",
      student: "学生",
      meeting_with: "会见对象",
      date_time: "日期/时间",
      meeting_type: "会议类型",
      location: "地点",
      comment: "备注",
      action: "操作",
      delete: "删除",
      add_comment: "添加备注",
      join: "加入会议",
      choose_meeting_type: "选择会议类型",
      in_person: "现场",
      phone: "电话",
      callback: "回电",
      virtual: "线上",
      hybrid: "混合",
      unavailable: "不可用",
      tooltip_translator: "翻译服务无法保证，但学校会尽一切努力确保提供。",
      translator_requested: "已请求{language}口译",
      clear_translator: "清除口译请求",
      need_translator: "需要口译？",
      choose_language: "选择语言"
    },
    ScheduleMatrix: {
      no_teachers_title: "未选择教师或团队。",
      no_teachers_message: "请选择教师以查看他们的会议时间。",
      choose_teachers_button: "查看可用教师或团队",
      choose_student: "为哪位学生？",
      cancel: "取消"
    },
    Matrix: {
      teachers: "教师",
      agenda: "查看并继续"
    },
    DrawerTeachers: {
      teachers: "教师",
      name: "姓名",
      description: "描述",
      student: "学生",
      teacher_team: "教师/团队",
      show_more: "显示更多教师",
      show_all: "显示学校中所有教师",
      selected: "已选择（{count}）",
      closeDrawer: "继续安排",
      search: "搜索教师或团队",
      not_available: "该教师在 {date} 没有可用的会议时间。"
    },
    DrawerAgenda: {
      no_meetings_title: "您尚未安排任何会议。",
      no_meetings_message: "选择教师和时间段后，会议将显示在此处。",
      new_meeting_label: "新建",
      cancel_button: "取消",
      student_label: "学生",
      meeting_type_location: "会议类型/地点",
      comment_label: "备注",
      save_comment_button: "保存备注",
      confirm_label: "请确认：",
      confirm_cancel_button: "是的，取消我与 ",
      do_not_cancel_button: "不要取消",
      confirm_agenda_button: "确认此日程",
      confirm_agenda_message_line1: "您可以随时返回修改。",
      confirm_agenda_message_line2: "当前日程将通过邮件发送给您。"
    },
    EmailConsent: {
      message: "为了保护您的隐私与安全，我们需要您授权接收系统发送到您的电子邮箱的信息。",
      consent: "同意"
    },
    UserManagement: {
      pageTitle: "User Management",
      pageSubtitle:
        "Add and manage school and district staff accounts. Staff sign in with school or district login using this site's account.",
      addUser: "Add user",
      editUser: "Edit user",
      loading: "Loading users…",
      emptyTitle: "No staff users yet",
      emptyMessage: "Use Add user to create a school or district staff account.",
      tableUsername: "Username",
      tableEmail: "Email",
      tableRole: "Role",
      tableActions: "Actions",
      typeSchool: "School",
      typeDistrict: "District",
      roleTeam: "Team",
      roleSchool: "School Admin",
      roleReporter: "School Reporter",
      roleDistrict: "District Admin",
      roleNoIntegration: "School Admin without Integration",
      roleNotSet: "Role not set",
      roleUnknown: "Role ({id})",
      formUsername: "Username",
      formEmail: "Email",
      formPassword: "Password",
      formNewPassword: "New password (optional)",
      formRole: "Role",
      loginHint:
        "Staff sign in with the school portal. District staff may use the district portal subdomain when applicable.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDeleteTitle: "Remove this user?",
      confirmDeleteBody:
        "This will remove the staff account from your school. This action cannot be undone.",
      validationRequired: "Please fill in all required fields.",
      createdSuccess: "User created.",
      updatedSuccess: "User updated.",
      deletedSuccess: "User removed.",
      genericError: "Something went wrong. Please try again.",
      changeRoleTitle: "Change role",
      roleUpdatedSuccess: "Role updated.",
      deleteUserAria: "Remove user",
      formSchool: "School",
      validationSchoolRequired: "Please select a school.",
      schoolListEmpty: "No schools are available in this district."
    },
    StudentsDirectory: {
      saveLinkHousehold: "Save link household",
      saveLinkHouseholdNothing: "No changes to save.",
      saveLinkHouseholdSuccess: "Link household updated for {count} students.",
      saveLinkHouseholdError: "Could not update link household.",
      saveLinkHouseholdPartial: "Updated {saved} students; {failed} could not be saved."
    },
    Events: {
      loadError: "无法加载活动。",
      retry: "重试"
    }
  }
};
